import { ConfigApi } from '@backstage/core-plugin-api';

export const buildRequestInterceptor = (
  _idToken: string | null,
  configApi: ConfigApi,
) => {
  return (req: { url?: string; headers: Record<string, string> }) => {
    /**
     * Uncomment the following code block if you need to auto-insert the Bearer token in Swagger requests.
     * This will automatically add the Authorization header with the Bearer token to requests.
     */
    /*
    if (!idToken) {
      console.error('Interceptor: userEntityRef is null or undefined');
    } else {
      req.headers.Authorization = `Bearer ${idToken}`;
    }
    */

    try {
      const newOrigin = configApi.getString('dxmGateway.url');
      const originalUrl = new URL(req.url ?? '');

      originalUrl.href = originalUrl.href.replace(
        originalUrl.origin,
        newOrigin,
      );

      req.url = originalUrl.toString();
    } catch (error) {
      console.error('Interceptor: Failed to update request URL origin:', error);
    }

    return req;
  };
};
